import { useEffect, useState } from 'react';

export default function SplashScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Phase 1: fill to ~70% over ~1.8s
    const phase1 = setInterval(() => {
      setProgress(p => {
        if (p >= 70) { clearInterval(phase1); return p; }
        return p + Math.random() * 8;
      });
    }, 160);

    // Phase 2: slow crawl from 70→90% over ~1.5s
    const t1 = setTimeout(() => {
      const phase2 = setInterval(() => {
        setProgress(p => {
          if (p >= 90) { clearInterval(phase2); return p; }
          return p + Math.random() * 2.5;
        });
      }, 220);
      return () => clearInterval(phase2);
    }, 1900);

    return () => {
      clearInterval(phase1);
      clearTimeout(t1);
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{ backgroundColor: '#0D1B2A' }}
    >
      {/* Outer ambient glow */}
      <div
        className="absolute rounded-full pointer-events-none"
        style={{
          width: 560,
          height: 560,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -60%)',
          background: 'radial-gradient(circle, rgba(212,175,55,0.14) 0%, rgba(132,210,197,0.06) 45%, transparent 70%)',
          filter: 'blur(32px)',
          animation: 'splash-pulse 3.2s ease-in-out infinite',
        }}
      />
      {/* Inner tighter glow */}
      <div
        className="absolute rounded-full pointer-events-none"
        style={{
          width: 300,
          height: 300,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -60%)',
          background: 'radial-gradient(circle, rgba(132,210,197,0.20) 0%, transparent 65%)',
          filter: 'blur(16px)',
          animation: 'splash-pulse 3.2s ease-in-out infinite',
          animationDelay: '0.5s',
        }}
      />

      {/* Logo */}
      <div
        className="relative mb-10"
        style={{ animation: 'splash-logo-in 0.7s cubic-bezier(0.34,1.56,0.64,1) both' }}
      >
        {/* Glow halo behind logo */}
        <div
          className="absolute inset-0 rounded-[28px]"
          style={{
            boxShadow: '0 0 48px rgba(212,175,55,0.40), 0 0 96px rgba(132,210,197,0.20)',
            borderRadius: '24px',
          }}
        />
        <img
          src="/Kerkplanner_logo.png"
          alt="Kerkplanner"
          style={{
            width: 120,
            height: 120,
            borderRadius: '24px',
            display: 'block',
            position: 'relative',
          }}
        />
      </div>

      {/* App name */}
      <div style={{ animation: 'splash-fade-up 0.5s 0.3s ease-out both', textAlign: 'center' }}>
        <p
          className="text-2xl font-bold tracking-tight mb-1"
          style={{ color: '#FFFFFF', fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          kerkplanner<span style={{ color: '#D4AF37' }}>.app</span>
        </p>
        <p
          className="text-xs tracking-widest uppercase"
          style={{ color: 'rgba(163,228,215,0.55)', letterSpacing: '0.18em' }}
        >
          Schedule · Volunteer · Connect
        </p>
      </div>

      {/* Progress bar */}
      <div
        style={{
          marginTop: 40,
          width: 220,
          height: 3,
          borderRadius: 99,
          backgroundColor: 'rgba(255,255,255,0.07)',
          overflow: 'hidden',
          animation: 'splash-fade-up 0.5s 0.5s ease-out both',
        }}
      >
        <div
          style={{
            height: '100%',
            borderRadius: 99,
            background: 'linear-gradient(90deg, #84D2C5, #D4AF37)',
            boxShadow: '0 0 10px rgba(132,210,197,0.6)',
            width: `${Math.min(progress, 100)}%`,
            transition: 'width 0.18s ease-out',
          }}
        />
      </div>

      <style>{`
        @keyframes splash-pulse {
          0%, 100% { opacity: 0.6; transform: translate(-50%, -60%) scale(1); }
          50%       { opacity: 1;   transform: translate(-50%, -60%) scale(1.1); }
        }
        @keyframes splash-logo-in {
          from { opacity: 0; transform: scale(0.72); }
          to   { opacity: 1; transform: scale(1); }
        }
        @keyframes splash-fade-up {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
